import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Pill } from '@feathr/components';

function MetaConnectedBadge(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill
      indicatorVariant={'solid'}
      name={'meta-connected-badge'}
      theme={'green'}
      variant={'secondary'}
    >
      {t('Connected')}
    </Pill>
  );
}

export default MetaConnectedBadge;
